/**
 * Comment form to leave a comment on single posts (recipe etc.)
 */

// Import statements
import React, {Component} from "react"
import {Field, Form, Formik} from "formik"
import * as Yup from "yup"

/**
 * Define the comment form class
 */
class CommentForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSubmitting: false,
            formSubmitted: false,
        }
    }

    // render the class
    render() {

        // define the comment scheme
        const CommentSchema = Yup.object().shape({
            author_name: Yup.string()
                .min(2, "Graag een geldige naam opgeven")
                .max(245, "Je naam is te lang (245 karakters)")
                .required("Dit veld is verplicht"),
            author_url: Yup.string().url(),
            content: Yup.string()
                .min(2, "Graag een reactie invoeren")
                .max(65525, "Je reactie is te lang (maximaal 65525 karakters)")
                .required("Dit veld is verplicht."),
            author_email: Yup.string()
                .email("Ongeldig emailadres")
                .required("Jouw e-mailadres is verplicht. Deze wordt niet publiekelijk zichtbaar."),
        })

        // define the post id
        const postId = this.props.postId

        //  return information
        return (
            <div id="respond">
                <div className="row comment-collapse-wrapper">
                    <div className="col-12">
                        <h3 id="reply-title" className="comment-reply-title">
                            Geef een antwoord
                        </h3>
                        <small>
                            <a rel="nofollow" id="cancel-comment-reply-link" href="/#respond" style={{display: 'none'}}>Antwoord
                                annuleren</a>
                        </small>
                    </div>
                    <div className="col-12">
                        <button className="btn btn-tertiary" type="button" data-bs-toggle="collapse"
                                data-bs-target="commentform" aria-expanded="false" aria-controls="commentform">
                            Ik wil graag reageren
                        </button>
                    </div>
                </div>
                <Formik
                    initialValues={{
                        post: postId,
                        parent: 0,
                        author_name: "",
                        author_url: "",
                        author_email: "",
                        content: "",
                        //comment_post_ID: postId,
                        //comment_parent: 0,
                    }}
                    validationSchema={CommentSchema}
                    onSubmit={values => {
                        this.setState({isSubmitting: true})
                        // same shape as initial values
                        let target = `https://myfoodblog.nl/wp-json/wp/v2/comments`
                        fetch(target, {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(values),
                        })
                            .then(response => response.json())
                            .then(data => {
                                console.log(JSON.stringify(data))
                                this.setState({
                                    isSubmitting: false,
                                    formSubmitted: true,
                                })
                            })
                            .catch(error => {
                                console.error(error)
                                this.setState({isSubmitting: false})
                            })
                    }}
                >
                    {({errors, touched}) => (
                        <Form id={`commentform`} className={`comment-form collapse`}>
                            <p>
                                Jouw e-mailadres wordt niet gepubliceerd. Vereiste velden zijn gemarkeerd met *
                            </p>
                            <p>
                                <label htmlFor="comment">Reactie<span className="required">*</span></label>
                                <Field
                                    name="content"
                                    id="comment"
                                    component="textarea"
                                    rows="8"
                                />
                                {errors.content && touched.content ? (
                                    <p className="alert alert-danger">{errors.content}</p>
                                ) : null}
                            </p>
                            <p>
                                <label htmlFor="author">Naam<span className="required">*</span></label>
                                <Field
                                    name="author_name"
                                    id="author"
                                    size="30"
                                    type="text"
                                />
                                {errors.author_name && touched.author_name ? (
                                    <p className="alert alert-danger">{errors.author_name}</p>
                                ) : null}
                            </p>
                            <p>
                                <label htmlFor="email">E-mail<span className="required">*</span></label>
                                <Field
                                    name="author_email"
                                    id="email"
                                    type="email"
                                    size="30"

                                />
                                {errors.author_email && touched.author_email ? (
                                    <p className="alert alert-danger">{errors.author_email}</p>
                                ) : null}
                            </p>
                            <p>
                                <label htmlFor="url">Site</label>
                                <Field
                                    name="author_url"
                                    id="url"
                                    type="url"
                                    size="30"
                                />
                                {errors.author_url && touched.author_url ? (
                                    <p className="alert alert-danger">{errors.author_url}</p>
                                ) : null}
                            </p>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={
                                    this.state.isSubmitting || this.state.formSubmitted
                                        ? true
                                        : false
                                }
                            >
                                Reactie plaatsen
                            </button>
                            {this.state.formSubmitted ? (
                                <p className={`alert alert-success`}>
                                    Thanks! Your comment is awaiting moderation.
                                </p>
                            ) : (
                                ""
                            )}
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

/**
 * Export the CommentForm variable
 */
export default CommentForm
